var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BVForm',{attrs:{"schema":_vm.model,"observer":['sucursalId'],"hide-footer":""},on:{"watcher":_vm.reader}})
}
var staticRenderFns = []

export { render, staticRenderFns }